<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Employee Information</legend>
            </div>
            <div class="row">
                <div class="small-12 medium-6 columns lp">
                    <labeled-input label="First Name *" name="Employee First Name" validation='required|max:20' v-model='sampleobject.firstName'></labeled-input>
                </div>
                <div class="small-12 medium-6 columns lp">
                    <labeled-input label="Last Name *" validation='required|max:20' name="Employee Last Name" v-model='sampleobject.lastName'></labeled-input>
                </div>
            </div>
              <div class="row">
                <div class="medium-4 columns lp">
                    <div :class="{'error': errors.has('Telephone') }">
                        <label for="telephone">Telephone*</label>
                        <input id="telephone" @blur="formatShippingPhoneNumber()" type="text" v-validate="'required'" name="Telephone" class="full-txt" placeholder="" v-model='sampleobject.phone'>
                        <p class="error" v-if="errors.has('Telephone')">{{ errors.first('Telephone') }}</p>
                    </div>
                </div>
                <div class="medium-8 columns lp">
                  <labeled-input validation="required|email" label="Email *" name="Email" autocomplete="on" v-model='sampleobject.email' @change="validateEmail"></labeled-input>
                    <small class="duplicate-error" v-if="hasInvalidEmail" v-html="invalidEmail"></small>
                </div>
            </div>
          
         
        </fieldset>
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject"],
  inject: ["$validator"],
  components: { LabeledInput },
  methods: {
    formatShippingPhoneNumber() {
      this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
    },
    formatPhoneNumber(args) {
      var s2 = ("" + args).replace(/\D/g, "");
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    },
    validateEmail(email) {
      const emailFiltered = email;

      if (emailFiltered == null) {
        return;
      }

      if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com")) {
        if (this.sampleobject.programType == 'Employee' || this.sampleobject.programType == 'SalesRep') {
            this.hasInvalidEmail = false;
          } else {
            this.hasInvalidEmail = true;
          }
      } else {
        this.hasInvalidEmail = false;
      }

      this.$emit('hasInvalidEmail', this.hasInvalidEmail);
    }
  },
  created() {
    this.formatShippingPhoneNumber();
  },
  data() {
    return {
      hasInvalidEmail: false,
      invalidEmail: `This portal is strictly for employees of professional eyecare practices in a customer-facing role like opticians, optometrists, ophthalmologists, technicians, and eyewear consultants.`,
    };
  },
  watch: {
  'sampleobject.email': function(newEmail) {
    this.validateEmail(newEmail);
  }
},
};
</script>
